import { EstablishmentManagerQualificationDetailHeader } from "./components/establishmentManager/EstablishmentManagerQualificationDetailHeader";
import { EstablishmentManagerQualificationDetailContent } from "./components/establishmentManager/EstablishmentManagerQualificationDetailContent";
import { EstablishmentManagerQualificationDetailWrapper } from "./components/establishmentManager/EstablishmentManagerQualificationDetailWrapper";
import { useIsEstablishmentManager } from "../../common/utils/useIsEstablishmentManager";
import { EmployeeQualificationDetailHeader } from "./components/employee/EmployeeQualificationDetailHeader";
import { EmployeeQualificationDetailContent } from "./components/employee/EmployeeQualificationDetailContent";
import { JSX } from "react";

const QualificationDetailPageContainer = (): JSX.Element => {
    const isEstablishmentManager = useIsEstablishmentManager();

    return (
        <EstablishmentManagerQualificationDetailWrapper>
            {isEstablishmentManager ? (
                <>
                    <EstablishmentManagerQualificationDetailHeader />
                    <EstablishmentManagerQualificationDetailContent />
                </>
            ) : (
                <>
                    <EmployeeQualificationDetailHeader />
                    <EmployeeQualificationDetailContent />
                </>
            )}
        </EstablishmentManagerQualificationDetailWrapper>
    );
};

export default QualificationDetailPageContainer;
